import type { ReactNode } from 'react';

interface SiteButtonProps {
  href?: string;
  children: ReactNode;
  variant?: 'dark' | 'light' | 'cta';
  type?: 'button' | 'submit';
  disabled?: boolean;
  onClick?: () => void;
}

const LIGHT_VARIANT_CLASS = 'w-variant-6cc8cb48-f4c6-5f39-f8af-bcfb630263e0';

function getButtonClass(variant: SiteButtonProps['variant']) {
  switch (variant) {
    case 'light':
      return `button ${LIGHT_VARIANT_CLASS} w-inline-block`;
    case 'cta':
      return 'button button--cta w-inline-block';
    default:
      return 'button w-inline-block';
  }
}

function getTextWrapClass(variant: SiteButtonProps['variant']) {
  return variant === 'light' ? ` ${LIGHT_VARIANT_CLASS}` : '';
}

export function SiteButton({
  href,
  children,
  variant = 'dark',
  type = 'button',
  disabled = false,
  onClick,
}: SiteButtonProps) {
  const variantClass = getButtonClass(variant);
  const textWrapClass = getTextWrapClass(variant);

  const inner = (
    <div className="button-text-wrap">
      <div className="button-text-group">
        <div className={`paragraph-02 button-text-wrap${textWrapClass}`}>{children}</div>
        <div className={`paragraph-02 button-text-wrap${textWrapClass}`}>{children}</div>
      </div>
    </div>
  );

  if (href) {
    return (
      <a href={href} className={variantClass}>
        {inner}
      </a>
    );
  }

  return (
    <button type={type} className={variantClass} onClick={onClick} disabled={disabled}>
      {inner}
    </button>
  );
}
